import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  User,
  UserCredential,
} from "firebase/auth";
import { auth } from "../config/firebase";

// Create a Google auth provider
const googleProvider = new GoogleAuthProvider();

/**
 * Firebase Authentication Service
 */
export const firebaseAuth = {
  /**
   * Sign in with email and password
   */
  signInWithEmail: async (
    email: string,
    password: string
  ): Promise<UserCredential> => {
    return signInWithEmailAndPassword(auth, email, password);
  },

  /**
   * Sign in with Google
   */
  signInWithGoogle: async (): Promise<UserCredential> => {
    return signInWithPopup(auth, googleProvider);
  },

  /**
   * Sign out the current user
   */
  signOut: async (): Promise<void> => {
    return signOut(auth);
  },

  /**
   * Create a new user with email and password
   */
  createUser: async (
    email: string,
    password: string
  ): Promise<UserCredential> => {
    return createUserWithEmailAndPassword(auth, email, password);
  },

  /**
   * Send password reset email
   */
  resetPassword: async (email: string): Promise<void> => {
    return sendPasswordResetEmail(auth, email);
  },

  /**
   * Get the current user
   */
  getCurrentUser: (): User | null => {
    return auth.currentUser;
  },

  /**
   * Get the auth instance
   */
  getAuth: () => auth,
};

export default firebaseAuth;
